import Vue from 'vue'
import { isPC, Throttle, isMideaConnect, getCookie, getCookieOfToken } from '../utils/utils'
export const tagMixin = {
  data () {
    return {
      page: {
        pageNum: 1,
        pageSize: 12
      },
      tagType: 1,
      articleList: [],
      id: '',
      keywords: '',
      keyword: '',
      base_appkey: '',
      errorStatus: false,
      listNumber: 0
    }
  },
  filters: {
    showWeekday (input) {
      // console.log('input', this.formatDate(input, 'yyyy-MM-dd HH:mm:ss'))
      if (!input) {
        return input
      } else {
        const date = new Date(input)
        return date.getMonth() + 1 + '-' + date.getDate()
      }
    }
  },
  methods: {
    getArticleDetail (item) {
      this.$router.push({ name: 'articleDetailByTag', query: { base_appkey: this.keywords, sid: this.id, type: 'h5' }, params: { id: item.id } })
      // this.$router.push({ name: 'articleDetail', query: { id: item.id, base_appkey: this.keywords, sid: this.id, type: 'h5' } })
    },
    loadArticleList () {
      this.loadMoreArticleList()
    },
    loadMoreArticleList: Throttle(function () {
      if (Math.ceil(this.listNumber / 12) > this.page.pageNum) {
        ++this.page.pageNum
        this.getData()
      }
    }),
    validateParams () {
      // 查看文章。只有浏览器含有mideaconnect标识才可以实名评论。否则通通当游客身份处理。
      this.id = this.$route.params.id
      this.keywords = this.$route.params.keywords
      this.keyword = decodeURIComponent(this.$route.params.keywords)
      this.base_appkey = this.$route.params.appKeys
      if (typeof this.id === 'undefined' || typeof this.keywords === 'undefined' || typeof this.base_appkey === 'undefined') {
        this.$toastMessage({ icon: '&#xe69f;', message1: this.$t('lang.notEnoughParam') })
        this.errorStatus = true
        return true
      }
      return true
    },
    getData () {
      const id = this.$route.params.id
      const keywords = this.$route.params.keywords
      const appKeys = this.$route.params.appKeys
      console.log(id)
      console.log(keywords)
      console.log(appKeys)
      // {
      //   sid: _self.$route.params.id,
      //     pageSize: _self.page.pageSize,
      //   pageNum: _self.page.pageNum,
      //   keywords: _self.$route.params.keywords,
      //   tagType: _self.tagType || 1
      // }
      this.$store.dispatch('getListByCategoryId', {
        sid: this.id,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNum,
        keywords: decodeURIComponent(this.keywords),
        tagType: this.tagType || 1
      })
        .then(data => {
          if (this.articleList.length === 0) {
            this.articleList = data.data.data.imgtextMsgPage.list
            this.listNumber = data.data.data.imgtextMsgPage.total
          } else {
            this.articleList = this.articleList.concat(data.data.data.imgtextMsgPage.list)
          }
        })
      this.$store.dispatch('setShowLoadingPic', { showLoadingPic: false })
    }
  },
  created () {
    if (this.validateParams()) {
      const result = {
        /* eslint-disable */
        data: {
          baseUrl: CONFIG.baseUrl
        }
        /* esline-enable */
      }
      Vue.prototype.$baseUrl = result.data.baseUrl
      this.getData()
    }
    if (!isPC() && isMideaConnect()) {
      if (!sessionStorage.getItem('token')) {
        sessionStorage.setItem('token', getCookieOfToken('token'))
      }
      if (!sessionStorage.getItem('appkey')) {
        sessionStorage.setItem('appkey', getCookie('appkey'))
      }
      if (!sessionStorage.getItem('username')) {
        sessionStorage.setItem('username', getCookie('username'))
      }
    }
  }
}
